<template>
    <div class="main">
        <div v-for="(item, index) in lang" :key="index">
            <!-- 标题 -->
            <div class="titleWrap">
                <div class="title">
                    <h5>{{ item[4] }}</h5>
                    <span>{{ item[5] }}</span>
                </div>
            </div>
            <div class="itxst">
                <!-- 拼图的地方 -->
                <div class="bannerWrap">
                    <!-- <div class="banner"> -->
                    <TextPage
                        @create="handleCreated"
                        @join="handleJoin"
                        :puzzle="puzzleListIs"
                        :action="actionType"
                        :isShare="isShare"
                        :language="language"
                        :shareUUID="shareUUID"
                    ></TextPage>
                    <!-- </div> -->
                </div>
            </div>
            <!-- 右上角的！ -->
            <div class="tipBtn" @click="isTip = true">
                <img src="@/assets/images/tip.png" alt="" />
            </div>
            <!-- 右上角说明  -->
            <div class="loggedWrap" v-show="isTip">
                <div class="logged">
                    <div class="btn" @click="isTip = false"><img src="@/assets/images/pupup_x.png" alt="" /></div>
                    <div class="tipText">
                        {{ item[18] }}
                        <p></p>
                        <div v-html="detailMsg"></div>
                    </div>
                </div>
            </div>
            <!-- 被分享人选择 -->
            <div class="loggedWrap" v-show="isShared">
                <div class="logged">
                    <!-- <div class="btn" @click="isShared = false"><img src="@/assets/images/pupup_x.png" alt="" /></div> -->
                    <div class="text">
                        {{ isSharedTitle }}
                    </div>
                    <div class="close" @click="handleShareJoin">{{ item[22] }}</div>
                    <p></p>
                    <div class="close request" @click="handleShareCreate">
                        <h5>{{ item[23] }}</h5>
                        <span>{{ item[33] }}</span>
                    </div>
                </div>
            </div>
            <div class="loggedWrap" v-show="isCreated">
                <div class="logged">
                    <!-- <div class="btn" @click="isCreated = false"><img src="@/assets/images/pupup_x.png" alt="" /></div> -->
                    <div class="text">{{ item[34] }}</div>
                    <p></p>
                    <div class="close request" @click="isCreated = false">
                        <h5>{{ item[35] }}</h5>
                        <span>{{ item[33] }}</span>
                    </div>
                </div>
            </div>
            <!-- 登录 -->
            <div class="loggedWrap" v-show="isLogin">
                <!-- <div style="font-size: 36px;padding-bottom: 30px;" @mouseup="onFacebookLogin">Facebook(JavaScript)</div> -->
                <div class="logged">
                    <!-- <div class="btn" @click="isLogin = false"><img src="@/assets/images/pupup_x.png" alt="" /></div> -->
                    <div class="ftl">
                        <div class="beLogin">{{ item[0] }}</div>
                        <p></p>
                        <p></p>
                        <div class="wayLoginWrap" @click="onLogin('facebook')">
                            <span><img src="@/assets/images/butten_icon_facebook.png" alt="" /></span>
                            <div>{{ item[1] }}</div>
                        </div>
                        <p></p>
                        <div class="wayLoginWrap" style="background: #4c9eea" @click="onLogin('twitter')">
                            <span><img src="@/assets/images/butten_icon_twitter.png" alt="" /></span>
                            <div>{{ item[2] }}</div>
                        </div>
                        <p></p>
                        <div class="wayLoginWrap" style="background: #53b635" @click="onLogin('line')">
                            <span><img src="@/assets/images/butten_icon_line.png" alt="" /></span>
                            <div>{{ item[3] }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 第三者 前两完成 -->
            <div class="loggedWrap" v-show="isFinish">
                <div class="logged">
                    <div class="text">{{ errorTitle }}</div>
                    <div class="close" @click="handleCreateMy">{{ item[35] }}</div>
                    <p></p>
                    <div class="close" @click="handleClose">{{ item[26] }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BottomShare from '@/components/BottomShare'
import { myHTTP } from '../utils/net'
import draggable from 'vuedraggable'
import queryString from 'query-string'
import TextPage from '@/pages/text'
import { lang } from '@/tool/archeroLang'

let parsed = queryString.parse(location.search || '') || {}
if (parsed.d) {
    parsed.d = encodeURIComponent(parsed.d)
}
export default {
    props: ['language'],
    components: {
        BottomShare,
        draggable,
        TextPage
    },
    data() {
        let loginURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        if (window.location.href.indexOf('https://test-h5-archero') === 0) {
            loginURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        } else if (window.location.href.indexOf('https://h5-archero') === 0) {
            loginURL = 'https://giftcode-archero.habby.com/api/v1/thirdparty/auth'
        }

        let arr = []
        let positions = []
        for (let i = 0; i < 16; i++) {
            arr.push({
                filled: false
            })
            positions.push({})
        }
        return {
            shareUUID: '',
            dragTargetList: arr,
            positions,
            fillIndex: -1,
            minDt: Number.MAX_VALUE,
            username: '',
            loginURL,
            userId: '',
            isSharedTitle: '',
            errorTitle: '',
            d: '',
            isShared: false,
            isTip: true,
            isShare: false,
            isLogin: false,
            isCreated: false,

            puzzle: [],
            puzzleList: [],
            puzzleListIs: [],
            actionType: 'create',
            lang: [{}],
            detailMsg: '',
            isFinish: false
        }
    },
    created() {
        if (!parsed.d && !localStorage.getItem('d')) {
            this.isLogin = true //为true的时候需要登录 打开登录界面
        } else {
            this.init()
        }
        if (parsed.uuid) {
            localStorage.setItem('uuid', parsed.uuid)
        }
        for (var i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    mounted() {
        this.detailMsg = this.lang[0][19]

        if (localStorage.getItem('username')) {
            this.isSharedTitle = this.lang[0][21].replace('{Name}', localStorage.getItem('username'))
        }
        if (localStorage.getItem('username')) {
            this.errorTitle = this.lang[0][24].replace('{Name}', localStorage.getItem('username'))
        }
        window.fbAsyncInit = () => {
            FB.init({
                appId: '250812872464647',
                cookie: true, // Enable cookies to allow the server to access the session.
                xfbml: true, // Parse social plugins on this webpage.
                version: 'v14.0' // Use this Graph API version for this call.
            })
        }
    },
    methods: {
        handleClose() {
            localStorage.clear()
            let path = this.$route.path
            window.location = path
            this.showPage = 'main'
        },
        handleCreateMy() {
            console.log('bububu我要自己创建')
            this.isFinish = false
            this.actionType = 'create'
            this.puzzleListIs = []
        },
        // 分享并参加
        handleShareJoin() {
            console.log('我要一起参加')
            this.isShared = false
            this.actionType = 'join'
            this.puzzleListIs = this.puzzleList
        },
        handleShareCreate() {
            console.log('我要自己创建')
            this.isShared = false
            this.actionType = 'create'
            this.puzzleListIs = []
        },
        handleCreated(data) {
            this.create(data)
        },
        onLogin(loginType) {
            location.href = this.loginURL + '/' + loginType
        },
        onFacebookLogin() {
            FB.login(
                response => {
                    console.log('---------------- login -------------------', response)
                    if (response.status === 'connected') {
                        this.userId = '' + response.authResponse.userID
                        FB.api('/me', response => {
                            console.log('me', response)
                            alert(JSON.stringify(response))
                        })
                    } else {
                        // The person is not logged into your webpage or we are unable to tell.
                    }
                },
                { scope: 'public_profile' }
            )
        },
        init() {
            let d = parsed.d || localStorage.getItem('d')
            let uuid = parsed.uuid || localStorage.getItem('uuid')
            myHTTP
                .post('/api/v1/anniversary2022/fetch', {
                    d,
                    uuid
                })
                .then(res => {
                    if (res.data.code == 0) {
                        this.isLogin = false
                        let data = res.data.data
                        localStorage.setItem('d', d)
                        // 判断是否参加
                        if (data.anniversary) {
                            this.shareUUID = data.anniversary.uuid
                            this.puzzleListIs = data.anniversary.puzzle
                            this.actionType = 'create'

                            localStorage.setItem('loginType', data.anniversary.loginType)

                            // 判断是否完成
                            if (data.anniversary.action == 'create' && data.anniversary.joiner) {
                                this.$emit('handleGoFinish')
                                localStorage.setItem('myGiftCode', data.anniversary.myGiftCode)

                                localStorage.setItem('username', data.anniversary.joinerName)
                                localStorage.setItem('myGiftCode', data.anniversary.myGiftCode)
                            }
                            if (data.anniversary.action == 'join' && data.anniversary.creator) {
                                this.$emit('handleGoFinish')
                                localStorage.setItem('myGiftCode', data.anniversary.myGiftCode)

                                localStorage.setItem('username', data.anniversary.creatorName)
                                localStorage.setItem('myGiftCode', data.anniversary.myGiftCode)
                            }
                            if (data.anniversary.creator == data.anniversary.userId) {
                                this.isShare = true
                            }
                            // 判断是否为别人分享
                        } else if (data.creatorAnniversary) {
                            localStorage.setItem('username', data.creatorAnniversary.username)

                            let currentUser = data.userInfo.loginType + ':' + data.userInfo.userId
                            if (data.creatorAnniversary.creator && data.creatorAnniversary.joiner) {
                                if (currentUser !== data.creatorAnniversary.creator && currentUser !== data.creatorAnniversary.joiner) {
                                    this.isFinish = true
                                    return
                                }
                            }
                            this.puzzleList = data.creatorAnniversary.puzzle
                            this.actionType = 'join'
                            // if (data.creatorAnniversary.action == 'creat' && data.creatorAnniversary.joiner) {
                            //     this.$emit('handleGoFinish', '拼完了', true)
                            // }
                            this.isShared = true
                            if (data.creatorAnniversary.username) {
                                this.username = data.creatorAnniversary.username
                                this.puzzle = data.creatorAnniversary.puzzle
                            }
                        } else if (!data.anniversary && !data.creatorAnniversary) {
                            this.isCreated = true
                        }
                    } else {
                        console.log(res.data.message)
                    }
                })
        },
        handleJoin() {
            myHTTP
                .post('/api/v1/anniversary2022/join', {
                    d: parsed.d || localStorage.getItem('d'),
                    uuid: parsed.uuid || localStorage.getItem('uuid'),
                    puzzle: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                })
                .then(res => {
                    console.log(res)
                    if (res.data.code == 0) {
                        let data = res.data.data
                        localStorage.setItem('username', data.anniversary.creatorName)
                        localStorage.setItem('myGiftCode', data.anniversary.myGiftCode)
                        this.$emit('handleGoFinish')
                    } else {
                        console.log(res.data.message)
                    }
                })
        },
        create(data) {
            myHTTP
                .post('/api/v1/anniversary2022/create', {
                    d: parsed.d || localStorage.getItem('d'),
                    puzzle: data
                })
                .then(res => {
                    this.isShare = true

                    if (res.data.code == 0) {
                        let data = res.data.data
                        this.shareUUID = data.anniversary.uuid
                    } else {
                        console.log(res.data.message)
                    }
                })
        }
    }
}
</script>


<style scoped lang="less">
.itxst {
    margin: 10px;
    text-align: left;
}
.col {
    width: 20%;
    min-height: 10px;
    flex: 1;
    padding: 10px;
    border: solid 1px #eee;
    border-radius: 5px;
    float: left;
    img {
        width: 12.5rem;
        // height: 100px;
    }
}
.main {
    position: relative;
    height: 100vh;
    width: 100%;
    background: url('../assets/images/bg.png') 100% 100% no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 1;

    .titleWrap {
        padding: 0 5.625rem;
        // transform: translateY(-2rem);
    }
    .title {
        padding-top: 8.25rem;
        text-align: center;
        width: 56.25rem;
        height: 18.75rem;
        background: url('../assets/images/titlepic_bg.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        h5 {
            color: #fff;
            font-size: 3.375rem;
        }
        span {
            display: block;
            color: #cfebfd;
            font-size: 2.25rem;
            padding-top: 0.675rem;
        }
    }

    .bannerWrap {
        // padding: 0 4.6875rem;
    }
    .banner {
        // transform: translateY(-4rem);
        padding: 4.6875rem;
        background: url('../assets/images/puzzle_bg.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        height: 58rem;
        .col {
            width: 25%;
            flex: 1;
            border: solid 1px #eee;
            border-radius: 5px;
            float: left;
        }
        img {
            width: 12.5rem;
            // border: 0.375rem solid #fff;
            box-sizing: border-box;
            // box-shadow: 2px 2px 4px 8px rgba(255, 255, 255, 0.5);
            // width: 100%;
        }
    }
    .chipWrap {
        // text-align: center;
        padding: 0 6.5%;
        .chip {
            transform: translateY(-4rem);
            // width: 57.25rem;
            height: 33.875rem;
            background: rgba(0, 0, 0, 0.42);
            border-radius: 2.25rem;
            border: 2px solid #000000;
        }
    }

    .tipBtn {
        position: absolute;
        top: 2.25rem;
        right: 2.25rem;
        img {
            width: 4.25rem;
        }
    }

    .loggedWrap {
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.54);
        line-height: 1.2;
        .logged {
            position: absolute;
            width: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -70%);
            background: #ffffff;
            width: 56.25rem;
            box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.78);
            text-align: center;
            border-radius: 1.5rem;
            padding: 1.125rem 3.125rem 6.25rem;
        }
        .btn {
            height: 4rem;
            text-align: right;
            img {
                width: 4rem;
            }
        }
        p {
            height: 3rem;
        }
        .text {
            padding: 3.5rem 7.25rem 7.5rem;
            font-size: 2.25rem;
            span {
                color: #4380ff;
            }
        }
        .tipText {
            color: #000000;
            font-size: 2.25rem;
            font-weight: 400;
            line-height: 2.8125rem;
            padding: 3rem 4rem;
            text-align: left;
            div {
                p {
                    height: 1rem;
                }
            }
        }
        .close {
            min-width: 39.5625rem;
            min-height: 10.4375rem;
            line-height: 10.4375rem;
            color: #ffffff;
            font-size: 3.125rem;
            display: inline-block;
            border-radius: 4.8125rem;
            background: #568dff;
        }
        .request {
            // min-height: 9.4375rem;

            line-height: 1;
            padding-top: 1.175rem;
            // padding-bottom: 1.875rem;

            h5 {
                line-height: 1.2;
            }
            span {
                display: block;
                color: #d2fdff;
                font-size: 1.875rem;
                min-height: 5.75rem;
                padding: 0.8rem 1.25rem;
            }
        }
        .ftl {
            padding: 0 4.25rem;
            .beLogin {
                padding-top: 5.625rem;
                color: #393939;
                font-size: 2.25rem;
            }
            .wayLoginWrap {
                display: flex;
                background: #3975ea;
                border-radius: 5rem;
                overflow: hidden;
                padding: 1rem 0;
                height: 9.875rem;

                div {
                    display: flex;
                    justify-content: space-around;
                    flex-direction: column;
                    align-items: center;
                    word-break: break-all;
                    color: white;
                    font-size: 2.625rem;
                    line-height: 1.3;
                    padding-left: 3rem;
                    padding-right: 3rem;
                }
                span {
                    padding-left: 2rem;
                    img {
                        width: 7.875rem;
                    }
                }
            }
        }
    }
}
.drag-list {
    display: flex;
    flex-wrap: wrap;
}

.drag-item {
    background: #ff9393;
    width: 8.5rem;
    height: 12.5rem;
    line-height: 50px;
    text-align: center;
    border: 1px solid #eee;
    box-sizing: border-box;
    color: #fff;
    // padding: 15px;
    flex: 1 0 25%;
    img {
        // width: 8.5rem;
    }
}
.drag-item:nth-child(1) {
    background: skyblue;
    img {
        height: 12.5rem;
        width: auto;
    }
}

.drag-item2 {
    background: #52c7f3;
    height: 80px;
    border: 1px solid #eee;
    box-sizing: border-box;
    color: #fff;
    padding: 15px;
    flex: 1 0 25%;
}

.drag-item-fill {
    background: limegreen;
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue